import Image from 'next/image'

export type LogoProps = {
  name: string
  altText?: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const logos: {
  [key: string]: {
    src: string
    height: number
    width: number
  }
} = {
  applepay: {
    src: '/embedded/logos/applepay.svg',
    height: 25,
    width: 59,
  },
  gpay: {
    src: '/embedded/logos/gpay.svg',
    height: 25,
    width: 55,
  },
  paypal: {
    src: '/embedded/logos/paypal.svg',
    height: 25,
    width: 74,
  },
  venmo: {
    src: '/embedded/logos/venmo.svg',
    height: 25,
    width: 78,
  },
  plaid: {
    src: '/embedded/logos/plaid.svg',
    height: 24,
    width: 62,
  },
}

export const Logo = ({ name, altText = '' }: LogoProps) => {
  const logo = logos[name]

  return <Image src={logo.src} width={logo.width} height={logo.height} alt={altText} />
}
